/* Component Dependencies */
var AriesComponent = require('libs/aries-component');
var onePixelLineTemplate = require('templates/onePixelLine.hbs');

AriesComponent.create({
  type: 'onePixelLine',
  template: {
    'onePixelLine': onePixelLineTemplate
  }
});